const patterns = {
  CPF: /^\d{11}$/,
  CNPJ: /^[A-Z0-9]{12}\d{2}$/,
  EMAIL:
    /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/,
  PHONE: /^\+[1-9]\d{7,14}$/,
  EVP: /^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/,
};

export const normalizePixKey = (type, value) => {
  const key = String(value || '').trim();
  if (type === 'CPF' || type === 'CNPJ')
    return key.replace(/[./ -]/g, '').toUpperCase();
  if (type === 'EMAIL' || type === 'EVP') return key.toLowerCase();
  if (type === 'PHONE') {
    const number = key.replace(/[() -]/g, '');
    if (/^\d{10,11}$/.test(number)) return `+55${number}`;
    if (/^55\d{10,11}$/.test(number)) return `+${number}`;
    return number;
  }
  return key;
};

export const isValidPixKey = (type, value) => {
  const key = normalizePixKey(type, value);
  if (key.length > 77 || !patterns[type]?.test(key)) return false;
  if (type === 'PHONE' && key.startsWith('+55'))
    return /^\+55[1-9]\d{9,10}$/.test(key);
  if (type !== 'CPF') return true;
  if (/^(\d)\1{10}$/.test(key)) return false;
  return [9, 10].every(length => {
    const sum = [...key.slice(0, length)].reduce(
      (total, digit, index) => total + Number(digit) * (length + 1 - index),
      0
    );
    return ((sum * 10) % 11) % 10 === Number(key[length]);
  });
};

export const displayPixKey = (type, value) => {
  const key = String(value || '');
  return type === 'PHONE' && /^\+55\d{10,11}$/.test(key) ? key.slice(3) : key;
};
